export const wait = (time = 0) => new Promise(res => setTimeout(res, time));

export const isNullOrUndefined = (value: unknown): value is null | undefined => value === null || value === undefined;
